<template>
  <div>
    <label class="field_label">{{ current_champ.label }}<span class="text-red" v-if="current_champ.mandatory == 1">*</span></label>
    <div class="my-1">
      <v-btn v-if="is_mineur" density="compact" color="primary-dark" variant="elevated" elevation="0" @click="display_popup_mineur = true">Ouvrir le questionnaire de santé pour les mineurs</v-btn>
      <v-btn v-else density="compact" color="primary-dark" variant="elevated" elevation="0" @click="display_popup_majeur= true">Ouvrir le questionnaire de santé</v-btn>
    </div>
    
    <v-select :items="items" v-model="current_champ.value" ref="field" @blur="$refs.field.validate()" :disabled="is_disable" :rules="[$formRules.userInput(current_champ, inscription.list_courses, inscription.list_packs_courses, mode)]"></v-select>
    <DialogFormQuestionnaireSanteFFRMajeur v-if="display_popup_majeur" :inscription="inscription" @unvalidate="unvalidate" @validate="validate"></DialogFormQuestionnaireSanteFFRMajeur>
    <DialogFormQuestionnaireSanteFFRMineur v-if="display_popup_mineur" :inscription="inscription" @unvalidate="unvalidate" @validate="validate"></DialogFormQuestionnaireSanteFFRMineur>
  </div>
</template>

<script>

import DialogFormQuestionnaireSanteFFRMajeur from "@/components/Inscription/Champs_Formulaire/DialogFormQuestionnaireSanteFFRMajeur.vue";
import DialogFormQuestionnaireSanteFFRMineur from "@/components/Inscription/Champs_Formulaire/DialogFormQuestionnaireSanteFFRMineur.vue";
export default {
  components: { DialogFormQuestionnaireSanteFFRMajeur, DialogFormQuestionnaireSanteFFRMineur},

  props: ["champ", "inscription", "mode", "is_disable","is_mineur"],
  data() {
    return {
      display_popup_majeur: false,
      display_popup_mineur: false,
      current_champ: {},
      items: [
        { title: "Sélectionner", value: "" },
        { title: "J'ai répondu NON à toutes les questions", value: 1 },
        { title: "J'ai répondu OUI à une ou plusieurs questions", value: 0 },
      ],
    };
  },
  watch: {
    champ: {
      deep: true,
      handler() {
        this.current_champ = this.champ;
        this.$forceUpdate();
      },
    },
    is_mineur: {
      deep: true,
      handler() {
        this.current_champ.value = "";
      },
    }
  },
  methods: {
    unvalidate() {
      this.current_champ.value = 0;
      this.display_popup_majeur = false;
      this.display_popup_mineur = false;
    },
    validate() {
      this.current_champ.value = 1;
      this.display_popup_majeur = false;
      this.display_popup_mineur = false;
    },
    },
  
  created() {
    this.current_champ = this.champ;
    if (this.current_champ.value == "1") {
      this.current_champ.value = 1;
    } else if (this.current_champ.value == "0") {
      this.current_champ.value = 0;
    } else {
      this.current_champ.value = "";
    }
  },
};
</script>

<style lang="scss">
.v-autocomplete__content {
  max-height: 300px !important;
  min-height: auto !important;
}
</style>